import React from "react";
import { Globe, Hexagon, RefreshCw } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const promises = [{
  title: "Immersive Worlds",
  description: "Step into meticulously crafted universes where every detail draws you deeper into the narrative and gameplay.",
  icon: Globe
}, {
  title: "Premium Components",
  description: "Experience the tactile satisfaction of high-quality materials, designed for durability and aesthetic perfection.",
  icon: Hexagon
}, {
  title: "Strategic Replay",
  description: "Discover endless possibilities with dynamic mechanics that ensure no two gaming sessions are ever exactly the same.",
  icon: RefreshCw
}];
export default function AnalogPromise() {
  return <section id="analog-promise" className="bg-background py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16 md:mb-24">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-foreground tracking-wide">
            The Analog Promise
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {promises.map((promise, i) => {
          const Icon = promise.icon;
          return <Card key={i} data-index={i} className="group bg-card border-border transition-all duration-500 hover:-translate-y-2 hover:border-primary hover:shadow-2xl flex flex-col h-full">
                <CardHeader className="pb-4">
                  <div className="mb-6 relative inline-flex self-start">
                    {}
                    <Icon className="w-12 h-12 text-foreground relative z-10 transition-transform duration-500 group-hover:scale-110" strokeWidth={1} />
                    {}
                    <div className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-primary rounded-full shadow-md transition-all duration-500 group-hover:shadow-lg group-hover:scale-125 z-20" />
                    {}
                    <div className="absolute inset-0 bg-primary/0 blur-xl rounded-full transition-all duration-500 group-hover:bg-primary/20" />
                  </div>
                  <CardTitle className="font-serif text-xl md:text-2xl text-card-foreground tracking-wide">
                    {promise.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow">
                  <CardDescription className="font-sans text-base text-card-foreground/80 leading-relaxed">
                    {promise.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}